
export const Routes = {
    // pages
    Presentation: { path: "/presentation" },
    DashboardOverview: { path: "/dashboard/overview" },
    AdminDashboard: { path: "/dashboard/admin" },
    Profile: { path: "/dashboard/profile" },
    Transactions: { path: "/transactions" },
    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signin: { path: "/" },
    Signup: { path: "/examples/sign-up" },
    ConfirmRegistration: { path: "/examples/confirm-registration" },
    ForgotPassword: { path: "/examples/forgot-password" },
    ResetPassword: { path: "/examples/reset-password" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },
    DetailOptionPage: { path: "/dashboard/detailoption/:id" },
    ListDetailOptionPage: { path: "/dashboard/detailoption-list" },
    ListCiemPage: { path: "/dashboard/ciem" },
    ListTeamPage: { path: "/dashboard/team" },
    ListProductPage: { path: "/dashboard/product" },
    LegalPage: { path: "/dashboard/legal" },
    ContributionPage: { path: "/dashboard/contribution" },
    PerfilMercadoPage: { path: "/dashboard/perfilMercado" },
    MercadoPotencialPage: { path: "/dashboard/mercadoPotencial" },
    MercadoObjetivoPage: { path: "/dashboard/mercadoObjetivo" },
    CompetitorPage: { path: "/dashboard/competitor" },
    MercadoPage: { path: "/dashboard/mercado" },
    MercadoConsumidaPage: { path: "/dashboard/mercadoConsumida" },
    EmpleadoPage: { path: "/dashboard/empleado" },
    EmpleadoVentaPage: { path: "/dashboard/empleadoVenta" },
    EmpleadoDirectoPage: { path: "/dashboard/empleadoDirecto" },
    EmpleadoIndirectoPage: { path: "/dashboard/empleadoIndirecto" },
    CostosFijosMensualPage: { path: "/dashboard/costosFijosMensual" },
    CostosSemifijoPage: { path: "/dashboard/costosSemifijo" },
    CostosVentasPage: { path: "/dashboard/costosVentas" },
    CostosTotalPage: { path: "/dashboard/costosTotal" },
    PeuPage: { path: "/dashboard/peu" },
    CapacidadInstaladaPage: { path: "/dashboard/capacidadInstalada" },
    InversionSerVivoPage: { path: "/dashboard/inversionSerVivo" },
    InversionMaquinariaPage: { path: "/dashboard/inversionMaquinaria" },
    InversionHerramientaPage: { path: "/dashboard/inversionHerramienta" },
    InversionSoftwarePage: { path: "/dashboard/inversionSoftware" },
    InversionMueblesPage: { path: "/dashboard/inversionMuebles" },
    InversionComputadorasPage: { path: "/dashboard/inversionComputadoras" },
    InversionVehiculosPage: { path: "/dashboard/inversionVehiculos" },
    InversionPropiedadPage: { path: "/dashboard/inversionPropiedad" },
    InversionEstrategicoPage: { path: "/dashboard/inversionEstrategico" },
    InversionTotalPage: { path: "/dashboard/inversionTotal" },
    InversionCapitalTrabajoPage: { path: "/dashboard/inversionCapitalTrabajo" },
    UserAdministrationPage: { path: "/dashboard/user-administration" },
    BusinessModelRatingPage: { path: "/dashboard/business-model-rating" },
    FinanciacionPage: { path: "/dashboard/financiacion" },
    TasaRetornoPage: { path: "/dashboard/tasa-retorno" },
    CalculoCostoCapitalPage: { path: "/dashboard/calculo-costo-capital" },
    GastosPage: { path: "/dashboard/gastos" },
    PlanDeNegocioPage: { path: "/dashboard/plan-de-negocio" },
    InversoresPage: { path: "/dashboard/inversores" },
    SectorExternoPage: { path: "/dashboard/sector-externo" },
    EstructuraProduccionPage: { path: "/dashboard/estructura-produccion" },
    EstadoResultadosPage: { path: "/dashboard/estado-resultados" },
    RepresentacionGraficaPage: { path: "/dashboard/representacion-grafica" },
    CartaIntencionPage: { path: "/dashboard/carta-intencion" },
    UserStatsDashboard: { path: "/dashboard/user-stats" },
    CiemStatsDashboard: { path: "/dashboard/ciem-stats" },
    ReportePdfPage: { path: "/dashboard/reporte-pdf" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};